import { ApiService } from "./api.service";
export default class SearchEventService extends ApiService {
  template = "defaultTemplate";
  namespace = "searchEvent";
  icon = "Property";
  // action = "action";
  favicon = "Magnifier";

  Width = 750;

  constructor() {
    super("services");
  }
}
